<div class="fx-admin-ib_mam">
  <div class="row">
    <div class="col">
      <fx-tab
        [tabs]="tabs"
        [activeTab]="tabSelect"
        (selected)="onChangeTab($event)">
      </fx-tab>
    </div>
  </div>
  <div class="row" *ngIf="tabSelect == tabs[0]">
    <div class="col">
      <fx-mam-master
        [permission]="permission"
      ></fx-mam-master>
    </div>
  </div>
  <div class="row" *ngIf="tabSelect == tabs[1]">
    <div class="col">
      <app-mam-follower
        [permission]="permission"
      ></app-mam-follower>
    </div>
  </div>
</div>
